import { render, staticRenderFns } from "./assemblySubItemDialog.vue?vue&type=template&id=36c09128&"
import script from "./assemblySubItemDialog.vue?vue&type=script&lang=js&"
export * from "./assemblySubItemDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports